export default __webpack_public_path__ + "static/media/dark_look_up.d508b910.jpg";